// extracted by mini-css-extract-plugin
export default {"emotionWrapper":"Emotion_emotionWrapper__cgQ19"};